import { Controller } from "stimulus";

export default class extends Controller {
  togglePassword() {
    const showPasswordToggle = document.getElementById("password-toggle-checkbox");
    const passwordInput = document.getElementById("user_password");
    if (showPasswordToggle.classList.contains("true")) {
      showPasswordToggle.classList.remove("true");
    } else {
      showPasswordToggle.classList.add("true");
    }

    if (showPasswordToggle.classList.contains("true")) {
      passwordInput.type = "text";
    } else {
      passwordInput.type = "password";
    }
  }

  toggleConfirmationPassword() {
    const showPasswordToggle = document.getElementById("password-confirmation-checkbox");
    const passwordInput = document.getElementById("user_password_confirmation");
    if (showPasswordToggle.classList.contains("true")) {
      showPasswordToggle.classList.remove("true");
    } else {
      showPasswordToggle.classList.add("true");
    }

    if (showPasswordToggle.classList.contains("true")) {
      passwordInput.type = "text";
    } else {
      passwordInput.type = "password";
    }
  }
}
